import React, { useState } from "react";
import { useSelector } from "react-redux";

import sortDataByDate from "../../../../functions/sorting/sortDataByDate";
import MobileActionHeader from "../../../../components/UI/headingsUI/MobileActionHeader";
import {
  RECEIVER_REJECTED_FILTERS,
  RECEIVER_REJECTED_SEARCH_FILTERS,
} from "../../utils/expenseFilters.config";
import FilterSearch from "../../../../components/common/FilterSearch";
import ExpenseViewDialog from "../../../../components/UI/viewDialogs/expense/ExpenseViewDialog";
import ImageSlider from "../../../../components/UI/viewDialogs/ImageSlider";
import { TableView } from "./TableView";

const ReceiverRejectedExpenses = () => {
  const [viewDialogDetails, setViewDialogDetails] = useState({});
  const [imageSliderPics, setImageSliderPics] = useState([]);
  const [imageSliderCurrentIndex, setImageSliderCurrentIndex] = useState();

  const isSorted = useSelector((state) => state.data.isSorted);
  const expenseData = useSelector((state) => state.data.data);
  const copyData = useSelector((state) => state.data.copyData);
  const isCopyData = copyData.length > 0;

  let dataList = isSorted ? expenseData : sortDataByDate(expenseData, "date");

  const closeViewDialog = () => {
    setViewDialogDetails({ ...viewDialogDetails, open: false });
  };

  const openImageSlider = (Pics) => {
    closeViewDialog();
    setImageSliderPics(Pics);
  };

  const closeImageSlider = () => {
    setImageSliderPics([]);
    setViewDialogDetails({ ...viewDialogDetails, open: true });
  };
  return (
    <>
      <MobileActionHeader title="Check History" />
      {isCopyData ? (
        <FilterSearch
          categories={RECEIVER_REJECTED_FILTERS}
          searchCategories={RECEIVER_REJECTED_SEARCH_FILTERS}
        />
      ) : (
        ""
      )}
      <TableView
        dataList={dataList}
        setViewDialogDetails={setViewDialogDetails}
      />
      {viewDialogDetails?.open && (
        <ExpenseViewDialog
          closeDialog={closeViewDialog}
          viewDetails={viewDialogDetails.data}
          openImageSlider={openImageSlider}
          setImageSliderCurrentIndex={setImageSliderCurrentIndex}
          setExpenseViewDetails={setViewDialogDetails}
        />
      )}
      {imageSliderPics.length !== 0 && (
        <ImageSlider
          title="Expense Photos"
          images={imageSliderPics}
          imageSliderCurrentIndex={imageSliderCurrentIndex}
          closeDialogBox={closeImageSlider}
        />
      )}
    </>
  );
};

export default ReceiverRejectedExpenses;
